'use client';

import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { useStore } from '@base-ui/utils/store';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { schedulerOtherSelectors } from '@mui/x-scheduler-internals/scheduler-selectors';
import { useSchedulerStoreContext } from '@mui/x-scheduler-internals/use-scheduler-store-context';
import { useEventDialogStyledContext } from '@mui/x-scheduler/internals';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const RecurringScopeDialog = /*#__PURE__*/React.forwardRef(function RecurringScopeDialog(props, ref) {
  // Context hooks
  const {
    schedulerId,
    localeText
  } = useEventDialogStyledContext();
  const store = useSchedulerStoreContext();

  // Selector hooks
  const open = useStore(store, schedulerOtherSelectors.isRecurringScopeDialogOpen);

  // Feature hooks
  const handleOpenChange = React.useCallback(next => {
    if (!next) {
      store.selectRecurringEventScope(null);
    }
  }, [store]);
  const handleSubmit = async event => {
    event.preventDefault();
    const form = new FormData(event.currentTarget);
    const recurrenceScopeValue = form.get('recurrenceScope');
    store.selectRecurringEventScope(recurrenceScopeValue);
  };
  return /*#__PURE__*/_jsx(Dialog, _extends({
    open: open,
    ref: ref,
    onClose: () => handleOpenChange(false),
    "aria-labelledby": `${schedulerId}-scope-dialog-title`
  }, props, {
    children: /*#__PURE__*/_jsxs("form", {
      onSubmit: handleSubmit,
      children: [/*#__PURE__*/_jsx(DialogTitle, {
        id: `${schedulerId}-scope-dialog-title`,
        children: localeText.title
      }), /*#__PURE__*/_jsx(DialogContent, {
        children: /*#__PURE__*/_jsx(FormControl, {
          children: /*#__PURE__*/_jsxs(RadioGroup, {
            "aria-label": localeText.radioGroupAriaLabel,
            defaultValue: "only-this",
            name: "recurrenceScope",
            children: [/*#__PURE__*/_jsx(FormControlLabel, {
              value: "only-this",
              control: /*#__PURE__*/_jsx(Radio, {}),
              label: localeText.onlyThis
            }), /*#__PURE__*/_jsx(FormControlLabel, {
              value: "this-and-following",
              control: /*#__PURE__*/_jsx(Radio, {}),
              label: localeText.thisAndFollowing
            }), /*#__PURE__*/_jsx(FormControlLabel, {
              value: "all",
              control: /*#__PURE__*/_jsx(Radio, {}),
              label: localeText.all
            })]
          })
        })
      }), /*#__PURE__*/_jsxs(DialogActions, {
        children: [/*#__PURE__*/_jsx(Button, {
          onClick: () => store.selectRecurringEventScope(null),
          type: "button",
          children: localeText.cancel
        }), /*#__PURE__*/_jsx(Button, {
          variant: "contained",
          type: "submit",
          children: localeText.confirm
        })]
      })]
    })
  }));
});
if (process.env.NODE_ENV !== "production") RecurringScopeDialog.displayName = "RecurringScopeDialog";